import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Divider,
  useTheme,
  Stack,
  Avatar,
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import BusinessIcon from "@mui/icons-material/Business";
import MedicalInformationIcon from "@mui/icons-material/MedicalInformation";
import NotesIcon from "@mui/icons-material/Notes";
import BadgeIcon from "@mui/icons-material/Badge";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import { useAuditoria } from "../contexts/AuditoriaContext";

const DatoItem = ({ icon: Icon, label, value }) => (
  <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
    <Icon sx={{ color: "primary.main" }} fontSize="small" />
    <Typography
      variant="body2"
      color="text.secondary"
      sx={{ minWidth: 90, textTransform: "capitalize" }}
    >
      <strong>{label}:</strong>
    </Typography>
    <Typography variant="body2" sx={{ textTransform: "capitalize" }}>
      {value}
    </Typography>
  </Stack>
);

const PanelDetallePrestacion = ({ prestacion, pagos, coseguro }) => {
  const theme = useTheme();

  const { fotoUrl } = useAuditoria();

  console.log("PanelDetallePrestacion", prestacion);

  if (!prestacion) {
    return null; // No renderizamos nada si no hay `prestacion`
  }

  return (
    <Box
      sx={{
        flexGrow: 1,
        overflowY: "auto",
        px: 2,
        py: 1,
        borderBottom: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
        {/* Avatar a la izquierda */}
        <Avatar
          key={prestacion?.documento_paciente || prestacion?.nombre_paciente}
          alt={prestacion?.nombre_paciente || ""}
          src={fotoUrl || null}
          sx={{ width: 72, height: 72, fontSize: 22 }}
        >
          {!fotoUrl && prestacion?.nombre_paciente
            ? prestacion.nombre_paciente
                .split(" ") // Separa apellido y nombre
                .map((part, index) => (index < 2 ? part.charAt(0) : "")) // Tomamos solo las iniciales del apellido y primer nombre
                .join("") // Unimos las iniciales
                .toUpperCase() // Convertimos a mayúsculas
            : null}
        </Avatar>

        {/* Contenedor para los datos del paciente */}
        <Box>
          <Typography
            variant="h6"
            color="primary"
            sx={{ textTransform: "capitalize" }}
          >
            {prestacion?.nombre_paciente?.toLowerCase() ?? ""}
          </Typography>
          {/* Documento */}
          <Typography variant="body1" color="text.primary">
            {prestacion?.documento_paciente ?? ""}
          </Typography>
          <Typography variant="body1" color="text.primary">
            {prestacion?.fnac_paciente
              ? `F.Nac: ${prestacion.fnac_paciente}${
                  prestacion.edad_paciente
                    ? ` (${prestacion.edad_paciente} años)`
                    : ""
                }`
              : ""}
          </Typography>

          {/* Paciente con edad */}
        </Box>
      </Box>

      <DatoItem
        icon={BusinessIcon}
        label="Obra social"
        value={
          prestacion?.razon_empresa
            ? `${prestacion.razon_empresa.toLowerCase()} (${
                prestacion.codigo_empresa ?? ""
              })`
            : ""
        }
      />

      <DatoItem
        icon={MedicalInformationIcon}
        label="Especialidad"
        value={
          prestacion
            ? `${prestacion.especialidad.toLowerCase()} ( ${prestacion.lista} )`
            : ""
        }
      />

      <DatoItem
        icon={RequestQuoteIcon}
        label="Coseguro"
        value={
          Number(coseguro?.[0]?.precio) > 0
            ? `$ ${Number(coseguro[0].precio).toFixed(2)}`
            : ""
        }
      />
      {pagos?.length > 0 && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle2" color="primary" sx={{ mb: 1 }}>
            Pagos en la semana
          </Typography>
          <Box
            component="table"
            sx={{
              width: "100%",
              borderSpacing: 0,
              fontSize: "0.85rem",
              "& th, & td": {
                padding: "4px 8px",
                textAlign: "left",
              },
              "& th": {
                fontWeight: "bold",
                color: "text.secondary",
                borderBottom: "1px solid #ccc",
              },
            }}
          >
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Importe</th>
                <th>Factura</th>
              </tr>
            </thead>
            <tbody>
              {pagos.map((pago, idx) => (
                <tr key={idx}>
                  <td>{pago.fecha_arg}</td>
                  <td>
                    ${" "}
                    {Number(pago.importe_total).toLocaleString("es-AR", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </td>

                  <td>{pago.referido_ticket ?? "-"}</td>
                </tr>
              ))}
            </tbody>
          </Box>
        </Box>
      )}

      <Box mt={2}>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
          <NotesIcon sx={{ color: "primary.main" }} fontSize="small" />
          <Typography variant="body2" color="primary">
            <strong>Notas:</strong>
          </Typography>
        </Stack>
        <Typography variant="body2">
          {prestacion?.comentario?.trim() || ""}
        </Typography>
      </Box>
    </Box>
  );
};

export default PanelDetallePrestacion;
